module.exports = __webpack_public_path__ + "img/iceland.cd7f20f6.svg";